/* eslint-disable */
import { ISupportDesk, ISupportData } from 'src/interfaces';
import http from './http';
import axios, { AxiosError } from 'axios';

class SupportDeskService {
  static getSupportTickets(params: any): Promise<{ items: ISupportDesk[]; meta: { totalItems: number } }> {
    let stringParams = '';
    // eslint-disable-next-line no-restricted-syntax
    for (const key in params) {
      if (stringParams === '') {
        stringParams += `${key}=${params[key]}`;
      } else {
        stringParams += `&${key}=${params[key]}`;
      }
    }
    return http
      .get(`support-ticket?${stringParams}`, {
        headers: { companyId: params.companyId },
      })
      .then(resp => resp.data);
  }

  // static addSupporTicket(formData: FormData) {
  //   return http
  //     .post(`/support-ticket`, formData, {
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //       },
  //     })
  //     .then(resp => resp.data)
  //     .catch((err: Error | AxiosError) => {
  //       if (axios.isAxiosError(err)) {
  //         throw new Error(err.response?.data?.message);
  //       } else {
  //         return err;
  //       }
  //     });
  // }

  static addSupporTicket(formData: FormData) {
    return http
      .post(`/crm-support-tickets`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static updateSupporTicket(formData: FormData) {
    return http
      .patch(`/crm-support-tickets`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static addSupporTicketReply(supportTicketId: string, formData: FormData) {
    return http
      .post(`/support-ticket/reply/${supportTicketId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static getSupportTicketsReply(params: any): Promise<ISupportData> {
    return http
      .get(`/support-ticket/support-ticket-reply/${params.ticketId}`, {
        headers: { companyId: params.companyId },
      })
      .then(resp => resp.data);
  }

  static reopenTicket(supportTicketId: string, ticket: any) {
    return http
      .post(`/support-ticket/reply-and-open/${supportTicketId}`, ticket, {})
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static downloadAttachment(attachmentId: string, type: 'ticket' | 'reply' = 'ticket'): Promise<Blob> {
    return http
      .get(`/support-ticket/download-attachment/${attachmentId}`, {
        params: { type },
        responseType: 'blob',
      })
      .then(resp => resp.data);
  }
}

export default SupportDeskService;
